import React, {
    createContext,
} from 'react';
import {CountryCode} from '@/types/Address';
import {Subscription} from '@/types/Subscription';

const CompanyProfileContext: React.Context<CompanyContext | {}> = createContext({});

const CompanyContextProvider = ({
                                    data,
                                    onRefresh = (force = false) => {},
                                    children
                                }: CompanyContextProviderProps) => {
    return (
        <CompanyProfileContext.Provider value={{
            onRefresh,
            ...data,
            getAreaCode: function () {
                const defaultAreaCode = data?.defaultAreaCode ?? '';

                if (!defaultAreaCode) return '+61';

                return data.defaultAreaCode;
            }
        }}>
            {children}
        </CompanyProfileContext.Provider>
    )
}

export {
    CompanyProfileContext
}

export default CompanyContextProvider;

type CompanyContextProviderProps = {
    onRefresh: (force: boolean) => void;
    data: CompanyContext; // Replace any with the specific type of your data.
    children: React.ReactNode;
};

type CompanyContext = {
    getAreaCode: () => string;
    billingTerms: string;
    companyName: string;
    country: CountryCode;
    customVariables: {
        area: 'client' | 'location';
        extra: string;
        name: string;
        type: string;
        value: string;
        inSearch?: '1' | '0';
    }[];
    defaultAreaCode: string;
    emailFooter: string;
    fullAddress: string;
    id: string;
    subscription: Subscription;
    flagClientPortal: boolean;
    flagFormSketch: boolean;
    flags: number;
    superAdminName: string;
}